module.exports = __webpack_public_path__ + "static/media/pic-17.a64aa3ac.jpg";